import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgPortugal = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M400 0H185.379v512H400c61.856 0 112-50.144 112-112V112C512 50.144 461.856 0 400 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#73af00"
                },
                d: "M112 0C50.144 0 0 50.144 0 112v288c0 61.856 50.144 112 112 112h73.379V0H112z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 185.45,
                cy: 256,
                r: 112.38
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M222.941 218.508v49.99c0 20.673-16.819 37.492-37.492 37.492s-37.492-16.819-37.492-37.492v-49.99h74.984m12.497-24.995h-99.98c-6.902 0-12.497 5.595-12.497 12.497v62.487c0 34.511 27.977 62.487 62.487 62.487s62.487-27.977 62.487-62.487V206.01c.001-6.902-5.595-12.497-12.497-12.497z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M211.931 229.517v35.31c0 14.603-11.88 26.483-26.483 26.483s-26.483-11.88-26.483-26.483v-35.31h52.966"
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 135.36,
                cy: 206.01,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 235.34,
                cy: 206.01,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 135.36,
                cy: 256,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 235.34,
                cy: 256,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 185.35,
                cy: 206.01,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 222.87,
                cy: 302.08,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("circle", {
                style: {
                    fill: "#ffe15a"
                },
                cx: 148.57,
                cy: 302.08,
                r: 6.249
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M193.52 252.832v10.762c0 4.451-3.621 8.071-8.071 8.071s-8.071-3.621-8.071-8.071v-10.762h16.142M193.52 227.317v10.762c0 4.451-3.621 8.071-8.071 8.071s-8.071-3.621-8.071-8.071v-10.762h16.142M193.52 278.608v10.762c0 4.451-3.621 8.071-8.071 8.071s-8.071-3.621-8.071-8.071v-10.762h16.142M215.26 252.832v10.762c0 4.451-3.621 8.071-8.071 8.071s-8.071-3.621-8.071-8.071v-10.762h16.142M171.779 252.832v10.762c0 4.451-3.621 8.071-8.071 8.071s-8.071-3.621-8.071-8.071v-10.762h16.142"
            })
        ]
    });
export { SvgPortugal };
